export interface MarketingCourse {
  id: number
  title: string
  description: string
  pictureUrl: string
  price: number
  category?: MarketingCourseCategoryEnum
}

export enum MarketingCourseCategoryEnum {
  ElectricAcousticGuitar,
  WorshipLeaderVocals,
  BassGuitar,
  KeysPianoSynth,
  Drums
}

export const marketingCourses: MarketingCourse[] = [
  {
    id: 0,
    title: 'The Worship Band Directing Mastery Course',
    description: `Tired of unprepared teams and Sunday morning chaos? Learn from leaders at Bethel, the Belonging Co., and Chris Tomlin Band how to build a worship team that shows up ready and sounds incredible every week. Transform your biggest headache into your greatest ministry strength.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/band_directing_course.png`
    ),
    price: 997
  },
  {
    id: 1,
    title: 'The Ultimate Worship Leadership Training',
    description: `Radically transform your life and community by becoming a 20X more valuable leader. This isn't the high level theories and concepts you hear every day. We're getting down in the dirt with techniques that you can put to use RIGHT NOW to become the leader you've always dreamed.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/lidership_training_course.png`
    ),
    price: 997
  },
  {
    id: 2,
    title: 'Master Worship Harmony',
    description: `Never struggle with finding your vocal part again! This is the little-known method for easily nailing professional sounding harmony parts while most singers struggle to even know what to sing. After this course, you'll be able to effortlessly find and sing beautiful alto, soprano, and /or tenor parts.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/singing_harmony_course.png`
    ),
    price: 800
  },
  {
    id: 3,
    title:
      'From Overwhelmed to Unstoppable: 10-Day Time Management for Worship Leaders',
    description: `Stop the Overwhelm. Start Leading with Purpose. Tired of feeling behind, scattered, and burned out as a worship leader? This 10-day system will completely transform how you manage`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/time_management_course.png`
    ),
    price: 997
  },

  {
    id: 4,
    title: 'The Worship Guitar Tone MasterClass',
    description: `Learn to master your tone with insights from Kari Jobe & Matt Redman's guitarists! Uncover gear secrets, amp & pedal nuances to sound incredible. No more tone struggles - we cover it all, step by step!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/guitar_tone_course.png`
    ),
    price: 297,
    category: MarketingCourseCategoryEnum.ElectricAcousticGuitar
  },
  {
    id: 5,
    title: 'Unlock Faster & Cleaner Electric Guitar Playing',
    description: `Discover the secrets of shredding with Benjamin Forehand (Israel Houghton & Tasha Cobbs)! Elevate your guitar skills, break through plateaus, and play faster, cleaner, with precision. Ben's proven methods reduce fatigue and make your notes pop! Master professional warm-ups and exercises!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/play_faster_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.ElectricAcousticGuitar
  },
  {
    id: 6,
    title: 'Building A Reliable And Flexible Pedalboard',
    description: `Craft your ultimate pedalboard with insights from touring pro Jordan Holt (Kari Jobe)! Discover the perfect balance of reliability & convenience. Learn the secrets of design, optimal cable management, and power supply choices. Elevate your setup.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/pedalboard_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.ElectricAcousticGuitar
  },
  {
    id: 7,
    title: 'Advanced Acoustic Guitar Technique',
    description: `Unlock the full potential of your guitar in worship with Bethel Music's JP Gentile! Dive into unique chord voicings, strumming patterns, fingerpicking, and explore alternate tunings. Ignite your creativity and passion, transforming your play into an inspirational musical experience!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/chord_inversions_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.ElectricAcousticGuitar
  },
  {
    id: 8,
    title: 'Sound Like a Pro for Under $200: Budget Worship Guitar Secrets',
    description: `You don't need expensive gear to sound amazing in worship settings. In this series, pro guitarist Chad Carouthers walks you through how to build killer worship tones using affordable pedals, amps-in-a-box, and creative signal chain tricks.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/gain_staging_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.ElectricAcousticGuitar
  },

  {
    id: 9,
    title: `Crush the Mission: The Elite Leader's Guide to Setting & Smashing Goals`,
    description: `How would you like to achieve in months what takes others years, without "grinding" or working harder? Now you can. We redesigned the entire goal setting framework from the ground up specifically for worship leaders and have seen this process change the lives of hundreds of people.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/goal_setting_course.png`
    ),
    price: 197,
    category: MarketingCourseCategoryEnum.WorshipLeaderVocals
  },
  {
    id: 10,
    title: 'How to Sing Higher and Stronger—Without Losing Your Voice',
    description: `Ready to hit those high notes? Vocal coach Brian Nhira shares 5 proven techniques to help you expand your vocal range, and keep your voice in top condition. Whether you're on stage leading worship or practicing in your car, these lessons will strengthen and protect your most valuable instrument. Perfect for any worship vocalist ready to grow!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/vocal_range_course.png`
    ),
    price: 197,
    category: MarketingCourseCategoryEnum.WorshipLeaderVocals
  },
  {
    id: 11,
    title: 'How to Build a Thriving Worship Team: 6 Proven Steps',
    description: `Discover 6 powerful strategies to grow and sustain a thriving worship team. Dive deep into practical, actionable steps that any worship leader can apply. Whether you're struggling with team retention or dreaming of building a dynamic group of musicians and vocalists, this is for you.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/grow_team_course.png`
    ),
    price: 197,
    category: MarketingCourseCategoryEnum.WorshipLeaderVocals
  },
  {
    id: 12,
    title: 'Effortlessly Control Your Vocal Pitch',
    description: `The DSB Method is our proprietary method for making anyone a better singer. This method is a mix of science and technique to teach you how to stay on pitch without even thinking about it, get a much more pleasing tone, and sustain breaths twice as long.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/control_pitch_course.png`
    ),
    price: 47,
    category: MarketingCourseCategoryEnum.WorshipLeaderVocals
  },
  {
    id: 13,
    title: 'Master Spiritual Singing',
    description: `Unlock your full potential in worship with our enriching training. Gain insights, enhance your skills, and elevate your worship experience. Dive into a world where humility, anointing, and preparation meet talent. Don't just sing, burn for God!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/spiritual_singing_course.png`
    ),
    price: 297,
    category: MarketingCourseCategoryEnum.WorshipLeaderVocals
  },

  {
    id: 14,
    title: 'Worship Bass Guitar Tone 101',
    description: `Boost your band's sound with the ultimate bass tone! Learn from David Curran (Elevation Worship, Kari Jobe, & Lauren Daigle) on selecting the perfect bass pedals and direct boxes, ensuring a clear, powerful, and balanced sound.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/bass_guitar_tone_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.BassGuitar
  },
  {
    id: 15,
    title: 'Build Killer Bass Technique with Tom Furby (Hillsong Y&F)',
    description: `Ready to increase your bass guitar chops and become a sought after bass player? Tom Furby from Hillsong Y&F takes you through how the pros increase their skill fast. Along with three of his favorite exercises that will drastically improve your playing in days.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/bass_guitar_technique_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.BassGuitar
  },
  {
    id: 16,
    title: 'How To Use A Bass Synth In Worship',
    description: `Enhance your music with sub bass! David (Elevation Worship), simplifies using a sub bass synth for rich, low-end tones. Save presets, fine-tune sounds, and elevate your live performances.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/bass_synth_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.BassGuitar
  },
  {
    id: 17,
    title: `The Bass Rig Behind Every Maverick City Hit (Sam Rady's Complete Setup)`,
    description: `Unlock iconic worship bass tones with Sam Rady, the genius behind Maverick City Music & Housefires' incredible sounds. Master versatile tones for any setting with a detailed walkthough and playthrough examples.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/bass_rig_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.BassGuitar
  },
  {
    id: 18,
    title: 'The 5 Best Bass Guitars For Worship',
    description: `No more guesswork or hours of reseach. Find the perfect bass for you with David Curran, the bassist behind Elevation Worship & Lauren Daigle's iconic sounds. Explore top picks, hear them in action, and find your match for quality, affordability, and versatility!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/best_guitars_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.BassGuitar
  },

  {
    id: 19,
    title: 'How To Build Pro Sounding Keyboard Patches',
    description: `Never wonder "How do I make that sound?" again. Unlock the secrets to iconic worship keys sounds in this in-depth training! Learn to create rich pads, ambient pianos, and energetic synths, enhancing your sound. Master unique sounds and effects, and elevate every performance!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/keyboard_patches_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.KeysPianoSynth
  },
  {
    id: 20,
    title: 'Crush Your End Of Sermon Playing',
    description: `Master end of sermon piano playing with insights from Evan Fernald of The Belonging Co.! Learn the perfect sounds and playing techniques to complement every message and transition smoothly into songs. Gain confidence and elevate your church service!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/end_of_sermon_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.KeysPianoSynth
  },
  {
    id: 21,
    title: 'Music Theory 101 & Advanced Music Theory',
    description: `Sit in with Music Director and Keyboardist for The Belonging Co. as he gives you the play by play, and coaches you through his own worship set. This series is a gold mine of knowledge.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/music_theory_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.KeysPianoSynth
  },
  {
    id: 22,
    title: 'Pro Worship Keyboard Setup: Hardware & Software',
    description: `Figuring out what keys gear to use for worship can be overwhelming task. We're here to help. Find out how to effortlessly switch sounds and control effects in real-time, ensuring a seamless experience even if your computer fails.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/keys_rig_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.KeysPianoSynth
  },
  {
    id: 23,
    title: 'Spontaneous Worship Piano: Flowing with Confidence',
    description: `You've practiced all your parts, and the set just ended, BUT... worship keeps going... What now? In this training we teach you how to flow, play by ear, and be prepared for any scenario where you may need to improvise on keys.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/spontaneous_keys_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.KeysPianoSynth
  },
  {
    id: 24,
    title: 'How To Tune Drums For Worship',
    description: `Unlock the secret to big, fat, amazing sounding drums! Learn from Austin Davis, the genius behind Kari Jobe and The Belongin Co's huge drum sound. And learn the "secret" behing Austin's signature snare sound. Your shortcut to mastering worship drum tone is here!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/tune_drums_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.Drums
  },
  {
    id: 25,
    title: 'How To Use An SPD-SX In Worship',
    description: `Elevate your drumming with the SPD-SX drum machine! Learn to master its use in worship. Unleash endless sound possibilities, effortlessly incorporate samples, and enhance your set with one tap.`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/spd_sx_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.Drums
  },
  {
    id: 26,
    title: 'Play Faster, Stronger, and More Consistently for Worship Drummers',
    description: `Unlock your full drumming potential with Rains Wall's (Sidewalk Prophets)! Break free from speed limits, learn effective exercises, and boost your hand speed & endurance. No more guesswork - follow a clear path to faster, more dynamic drumming!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/faster_drumming_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.Drums
  },
  {
    id: 27,
    title: 'Make You Live Drums Sound Like The Album With Samples',
    description: `Achieve consistent, high-quality drum tones with this "industry secret" - Worship Drums Samples! Learn from Payden Hilliard of Leeland. No need for expensive kits; access a vast range of sounds affordably. Elevate your sound and play with more confidence!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/drum_samples_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.Drums
  },
  {
    id: 28,
    title: 'Mic Your Drums Like a Pro: Church Services & Livestream Edition',
    description: `Unlock the secret to impeccable drum sound for live & streamed church services. Learn to choose the right mics, master placement techniques, and elevate your drum's sound to professional levels!`,
    pictureUrl: require(
      `@public/images/lab/marketing_courses/mic_drums_course.png`
    ),
    price: 27,
    category: MarketingCourseCategoryEnum.Drums
  }
]
